import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { IWidgetCard } from '@entities/widget-card/model/types';
import { widgetShopApi } from '@entities/widget-shop/api';
import { handleErrorInsideQuery } from '@shared/helpers';
import { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

export const useAddFreeWidgetQuery = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({
            widgetId,
            notMyCompany = false,
        }: {
            widgetId: IWidgetCard['id'];
            notMyCompany?: boolean;
        }) => widgetShopApi.addFreeWidget({ widgetId, notMyCompany }),
        onError: (error: AxiosError<IDataResponseError>) => {
            handleErrorInsideQuery(error, t('button.got_it.text'));
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: widgetShopApi.getWidgetCardsListQueryOptions().queryKey,
            });
        },
    });
};
